<template>

    <v-container justify-center fill-height v-if="loading">
      <v-progress-circular
        :size="150"
        :width="7"
        color="red"
        indeterminate
      />

      <span class="loader__version">{{ version }}</span>
    </v-container>

</template>

<style>
.loader__version {
  position: absolute;
  bottom: 2px;
  right: 2px;
}
</style>

<script>
// TODO: get app version via dispatcher to remove this dependency
const appVersion = require("../../package.json").version
const { detect } = require("detect-browser")

export default {
  name: "loader",
  data() {
    return {
      loading: true,
      token: "",
    };
  },
  mounted() {
    this.$store.dispatch('launch').then(() => {
      console.log("-- launched")
      this.$router.push({ name: 'AddClient' })
    })

    /*const browser = detect();
    console.log("-- add-client", browser);

    const storedConnection = localStorage.getItem("ippToConnect");
    if (storedConnection) {
      this.$store.dispatch("connectWsc").then((nodeurl) => {
        this.token = btoa(Date.now());

        this.$store
          .dispatch("registerWscToken", {
            token: this.token,
            name: browser.name,
            os: browser.os,
          })
          .then((status) => {
            console.log("-- token registered: " + status);
            setTimeout(() => {
              if (!this.$store.getters.isOnline) {
                this.$router.push({ name: "AddClient" });
              }
            }, 4000);
          });
      });
    } else {
      console.log("REDIRECT");
      this.$router.push({ name: "AddClient" });
    }*/
  },
  computed: {
    version() {
      return appVersion
    },
  },
};
</script>
